import React from 'react';
import { node, string } from 'prop-types';
import { colors } from '@styleseat/brand';
import { Box, Inline } from '@styleseat/ui';
import { BodyText } from '..';
import './Tag.module.scss';

const DARK_COLORS = [colors.blackInBlack];

const Tag = ({ children, borderColor, color }) => {
  const hasBorderColor = borderColor && borderColor !== 'transparent';
  /**
   * Make sure that the text color contrasts the tag's background color.
   * When it's a dark color, use white text, otherwise uses default text color.
   * Might need to add more dark backgrounds to the list later.
   */
  const textColor = DARK_COLORS.includes(color) ? colors.whiteWash : undefined;
  return (
    <Inline>
      <Box
        paddingY={0}
        paddingX={4}
        borderWidth={1}
        borderRightWidth={0}
        borderStyle="solid"
        borderColor={borderColor}
        borderRadius={0}
        color={color}
      >
        <BodyText
          weight="bold"
          textTransform="uppercase"
          appearance="small"
          color={textColor}
        >
          {children}
        </BodyText>
      </Box>
      {/* The following section renders the 45 degree cut tail */}
      <Box style={{ position: 'relative' }}>
        <Box
          borderStyle="solid"
          borderWidth={8}
          borderColor={hasBorderColor ? borderColor : color}
          borderLeftWidth={0}
          style={{
            position: 'absolute',
            borderRightColor: 'transparent',
            top: 0,
            left: 0,
            zIndex: 0,
          }}
        />
        {hasBorderColor && (
          <Box
            borderStyle="solid"
            borderWidth={7}
            borderColor={color}
            borderLeftWidth={0}
            style={{
              position: 'absolute',
              borderRightColor: 'transparent',
              top: 1,
              left: -1,
              zIndex: 1,
            }}
          />
        )}
      </Box>
    </Inline>
  );
};

Tag.propTypes = {
  children: node.isRequired,
  borderColor: string,
  color: string,
};

Tag.defaultProps = {
  borderColor: 'transparent',
  color: colors.blackInBlack,
};

export default Tag;
